// extracted by mini-css-extract-plugin
module.exports = {"main":"bx_n","header":"bx_bc","title":"bx_p","author":"bx_hh","date":"bx_t","post":"bx_k","subfooter":"bx_hj","banner":"bx_J"};